import { Button } from '@material-ui/core';
import { Link, ExtLink } from '@/components/global';
import { SocialUrls } from '@/constants';
import useStyles from './styles';

export default function Social() {
  const cls = useStyles();
  return (
    <section className={cls.card}>
      <div className={cls.col}>
        <div className={cls.headerRow}>
          <span />
          <span />
          <span />
          <h1>معرفی دکوژ</h1>
        </div>
        <h3>
          گروهی از اساتید، فارغ التحصیلان و متخصصان حوزه طراحی و تولید مبلمان،
          در دکوژ ، گرد هم آمدند تا با نیازسنجی بازار و بررسی فرایند طراحی ،
          تولید ، فروش ، عرضه و نیز خدمات محصولات مبلمانی کشور ، خالق بستری
          باشند متفاوت ، تا با رفع ایرادات و نقاط ضعف موجود در این هنر-صنعت ،
          گامی اثربخش در بهبود این فرایند بردارند.
        </h3>
        <div className={cls.butCont}>
          <Link href="/about">
            <Button className={cls.but2} variant="contained" disableElevation>
              مطالعه بیشتر
            </Button>
          </Link>
          <Link href="/merchant/login">
            <Button className={cls.but} variant="contained" disableElevation>
              پنل فروشندگان
            </Button>
          </Link>
        </div>
        <div className={cls.social}>
          <h5>دکوژ در شبکه اجتماعی</h5>
          <div className={cls.row}>
            {SocialUrls.map((i, idx) => (
              <ExtLink href={i.url} key={idx}>
                {i.icon}
              </ExtLink>
            ))}
          </div>
        </div>
      </div>

      <iframe
        className={cls.video}
        src="https://www.aparat.com/video/video/embed/videohash/3azik/vt/frame"
        title="معرفی دکوژ"
        allowFullScreen
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
      />
    </section>
  );
}
